export const DID_SPEC_V1 = 'https://www.w3.org/ns/did/v1';
export const MULTIKEY_SPEC_V1 = 'https://w3id.org/security/multikey/v1';
export const VERIFIABLE_CREDENTIALS_SPEC_V2 = 'https://www.w3.org/ns/credentials/v2';
export const OPEN_BADGE_SPEC_V3 = 'https://purl.imsglobal.org/spec/ob/v3p0/context-3.0.3.json';
export const OPEN_BADGE_EXTENSIONS_SPEC_V3 = 'https://purl.imsglobal.org/spec/ob/v3p0/extensions.json';
export const OPEN_BADGE_ACHIEVEMENT_CREDENTIAL_SCHEMA_V3 = 'https://purl.imsglobal.org/spec/ob/v3p0/schema/json/ob_v3p0_achievementcredential_schema.json';
export const TRUSTED_MICROCREDENTIAL_V1 = 'https://purl.imsglobal.org/spec/ob/v3p0/obv3p0_tcv1p0_context_v1p0.json';
export const TRUSTED_MICROCREDENTIAL_SCHEMA_V1 = 'https://purl.imsglobal.org/spec/ob/v3p0/schema/obv3p0_tcv1p0_trustedknowledgecredential_v1p0.json';
export const ISSUER_PROFILE_EXTENSION_V2 = 'https://purl.imsglobal.org/spec/ob-accred/v2p0/context/';
export const ISSUER_PROFILE_EXTENSION_SCHEMA_V2 = 'https://purl.imsglobal.org/spec/ob-accred/v2p0/schema/';
export const ASSESSMENT_EXTENSION_V2 = 'https://purl.imsglobal.org/spec/ob-assessment/v2p0/context/';
export const ASSESSMENT_EXTENSION_SCHEMA_V2 = 'https://purl.imsglobal.org/spec/ob-assessment/v2p0/schema/';
export const SCHEMA_VALIDATOR_2019 = '1EdTechJsonSchemaValidator2019';
export var CredentialType;
(function (CredentialType) {
    CredentialType["VC"] = "VerifiableCredential";
    CredentialType["OB30"] = "OpenBadgeCredential";
    CredentialType["TKC"] = "1EdTechTrustEdKnowledgeCredential";
})(CredentialType || (CredentialType = {}));
export var ProofMethod;
(function (ProofMethod) {
    ProofMethod["JWT"] = "JWT";
    ProofMethod["LINKED_DATA"] = "LINKED_DATA";
})(ProofMethod || (ProofMethod = {}));
//# sourceMappingURL=model.v3.js.map